export enum ActionType {
  SalesPipelineAction = 1,
  CRMAction = 2,
  // CRMActionSLAReview = 3
}

export enum ActionTaskType {
  PhoneCall = 1,
  Email = 2,
  InPersonVisit = 3,
  Presentation = 4,
  ProposalRequired = 5,
  SendProposal = 6,
  TenderRequired = 7,
  SLARequired = 8,
  SLAToBeReassigned = 9,
  OnHoldNoFurtherActionRequired = 10,

  CRMAction_Email = 11,
  CRMAction_Call = 12,
  CRMAction_InPersonVisit = 13,
  CRMAction_Presentation = 14,
  CRMAction_TeamsMeeting = 15,
  CRMAction_OnHoldNoFurtherActionRequired = 15,
  CRMAction_WebsiteEnquiryFollowUp = 17,
  CRMAction_SLAReminder = 18,
  CRMAction_SLAReview = 19
}

